import { render } from "./TwoParts.vue?vue&type=template&id=0ff88dc0&scoped=true"
import script from "./TwoParts.vue?vue&type=script&lang=js"
export * from "./TwoParts.vue?vue&type=script&lang=js"

import "./TwoParts.vue?vue&type=style&index=0&id=0ff88dc0&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff88dc0"]])

export default __exports__